import * as THREE from 'three'
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js'
import sources from './sources'


//botones y divs 
const containerButtonsKitchenPart = document.querySelector('div.contenedorBotones')
const containerConfigurator= document.querySelector('div.contenedorConfigurador')
const containerTextures= document.querySelector('div.contenedorTexturas')
const contenerdorLoading = document.querySelector('div.contenedorLoading')

//debug
const hitSound = new Audio('/assets/sounds/button_02.mp3')
hitSound.preload = 'auto'

//loaders
const gltfLoader = new GLTFLoader()
const textureLoader = new THREE.TextureLoader()

//canvas
const canvas = document.querySelector('canvas.webgl')

//scene
const scene = new THREE.Scene()

//light 
 const ambientLight = new THREE.AmbientLight('#FFFFFF', 0.3)

//pointsLight
const pointLight1= new THREE.PointLight('#eeeeee', 1.5, 10, 1)
pointLight1.position.set(0, 7.1, 1.7)

pointLight1.castShadow = true
pointLight1.shadow.mapSize.width = 512
pointLight1.shadow.mapSize.height = 512
pointLight1.shadow.camera.far = 2
pointLight1.shadow.radius= 3
pointLight1.shadow.bias = 0.05
pointLight1.shadow.normalBias = 0.05
 
const pointLight2 = new THREE.PointLight('#e7e7e7', 0.02, 3, 1)
pointLight2.position.set(-1.2, 2, 0)
pointLight2.rotation.x = -Math.PI * 0.5

const helper = new THREE.PointLightHelper(pointLight2)

const pointLight3 = new THREE.PointLight('#e7e7e7', 0.02, 3, 1)
pointLight3.position.set(1.2, 2, 0)
scene.add(ambientLight, pointLight1, pointLight2, pointLight3) 
 

//textureMap 
const textureMap = textureLoader.load('/assets/environment/environment.jpg', (file) => 
{
    file.mapping = THREE.EquirectangularReflectionMapping
})
textureMap.colorSpace = THREE.SRGBColorSpace


//espacio
const alphaMap = textureLoader.load('/assets/espacio/alpha.jpg')

const concreteMaterial = new THREE.MeshStandardMaterial({
    color: '#ebebeb',
    alphaMap: alphaMap,
    transparent: true
 })

 //floor
 const floor = new THREE.Mesh(
    new THREE.PlaneGeometry(20, 20), 
    concreteMaterial,
 )
floor.rotation.x = -Math.PI * 0.5
floor.receiveShadow= true


 //sphere
const geometry = new THREE.SphereGeometry(30)
geometry.scale(-1, 1, 1)
const sphere = new THREE.Mesh(
    geometry,
    new THREE.MeshLambertMaterial({
        color: '#e5e5e5', 
    })
 )


//sizes
const sizes = {
    width: window.innerWidth,
    height: window.innerHeight
}
window.addEventListener('resize', ()=> {
    sizes.width = window.innerWidth
    sizes.height = window.innerHeight

    //update camera
    camera.aspect = sizes.width / sizes.height
    camera.updateProjectionMatrix()

    //update renderer
    renderer.setSize(sizes.width, sizes.height)
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))

})

//camera
const camera = new THREE.PerspectiveCamera(28, sizes.width / sizes.height, 0.1, 100)
camera.position.set(4, 1.5, 17)
camera.lookAt(0, 0.658, 0.658)  
scene.add(camera)

//renderer
const renderer = new THREE.WebGLRenderer({canvas: canvas})
renderer.setSize(sizes.width, sizes.height)
renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
renderer.shadowMap.enabled = true
 renderer.toneMapping = THREE.CineonToneMapping
renderer.toneMappingExposure = 2.2 

 
//model

let model = null
gltfLoader.load('/assets/cocina/variation_1/cocina.gltf', (file)=>{
    model = file.scene
    model.scale.set(0.8, 0.8, 0.8)
   
    model.traverse((child) =>{
        if(child instanceof THREE.Mesh){
            child.castShadow = true
            child.material.envMap = textureMap
            child.material.envMapIntensity = 0.3

            if(child.name === 'Mesh'){
                child.material.roughness = 0.6
            }
        }
    })    

    scene.add(sphere, floor, model)
    renderer.shadowMap.needsUpdate = true
    contenerdorLoading.style.display = 'flex'
    loadConfigurator()
})  

renderer.shadowMap.autoUpdate = false

let controls
let gsap
const loadConfigurator = async () => {
    if(model){
        try{
            const { OrbitControls } = await import('three/examples/jsm/controls/OrbitControls.js')
            await getMesh()
            await loadTexture()
            await createButtonsMaterial()

            controls = new OrbitControls(camera, canvas)
            controls.target.set(0, 0.658, 0.658)
            controls.enableDamping = true  
            controls.minDistance = 1
            controls.maxDistance = 20
            controls.dampingFactor = 0.05

            const gsapModule = await import('gsap')
            gsap = gsapModule.default

            contenerdorLoading.style.display = 'none' 
      
            animation(containerConfigurator, 100, 0) 
    }catch (error) {
        console.error('Error al cargar configurador:', error)
    }
}}

//time
const clock = new THREE.Clock()
let oldElapsedTime = 0
 const tick = () =>{   

    const elapsedTime = clock.getElapsedTime()
    const deltaTime = elapsedTime - oldElapsedTime
    oldElapsedTime = elapsedTime

    //orbitControls
    if (controls) {
        controls.update()
    }

    // Render
    renderer.render(scene, camera)

    // Call tick again on the next frame
    window.requestAnimationFrame(tick)

}  
tick()   



const materials = {}
const variationsOfTextures = {}

const getMesh = async () =>{
    model.traverse((child) => {
        const arrayExcluir = ['wall', 'wallTile', 'handles']
        if(child instanceof THREE.Mesh){  
           const name = child.material.name
           if(!arrayExcluir.includes(name)){
           materials[name] = child.material

        const file = {
            pathBaseColor: child.material.map,
            pathNormal: child.material.normalMap,
            pathORM: child.material.roughnessMap,
        }
        if(!variationsOfTextures[name]){
         variationsOfTextures[name] = []
        }
        variationsOfTextures[name].push(file)
        }
    }
})   

}  

//cargar de variacion 2
const loadTexture = async () =>{
    for(const source of sources){
        const name = source.name
        const variations = source.variations
        for(const variation of variations){
            const texturesNew = {}
           for(const [key, path] of Object.entries(variation)){
                if(key !== 'id'){
                    textureLoader.load(path, (file)=>{
                        file.flipY = false
                        texturesNew[key] = file
                    })
                }
            }
            variationsOfTextures[name].push(texturesNew)
        } 
    }
} 

//creating buttons and containers

let variationsOfMaterials
const createButtonsMaterial = async () =>{
    const entry = Object.entries(variationsOfTextures)
    for(const [key, variations] of entry){
    const arrayExclude = ['islandBase', 'faucet']
    const included = arrayExclude.includes(key)
    if(!included){
        variationsOfMaterials = variations
        const buttonKitchenPart= document.createElement('button')
        buttonKitchenPart.id = key
        buttonKitchenPart.className = 'button'
        buttonKitchenPart.style.backgroundImage = `url('/assets/iconos/${buttonKitchenPart.id}.svg')`
        containerButtonsKitchenPart.appendChild(buttonKitchenPart)   
        createContainerVariations(buttonKitchenPart)

         }
     }
}

const createContainerVariations = (buttonKitchenPart) =>{
    const kitchenPart = buttonKitchenPart.id
    const containerVariations = document.createElement('div')
    containerVariations.id = `div-${kitchenPart}`
    containerVariations.className = 'contenedorVariations'
    containerTextures.appendChild(containerVariations)

    createButtonsVariations(kitchenPart, containerVariations)
    containerVariationsDisplay(buttonKitchenPart)
}

const createButtonsVariations = (kitchenPart, containerVariations) =>{
    variationsOfMaterials.forEach((item, index) =>{
        const buttonVariation = document.createElement('button')
        buttonVariation.className = 'buttonVariation'
        buttonVariation.id = `${kitchenPart}-${index}`
        buttonVariation.style.backgroundImage = `url('/assets/iconos/iconosArray/${buttonVariation.id}.png')`
        containerVariations.appendChild(buttonVariation)
        funcionalityButtonVariation(buttonVariation)
    })  
}

const containerVariationsDisplay = (buttonKitchenPart) => {
    buttonKitchenPart.addEventListener('click', (event) => {
        const buttons = document.querySelectorAll('.button')
        const containers = document.querySelectorAll('.contenedorVariations')
        const currentTarget = event.currentTarget
        const clickedId = currentTarget.id

        containers.forEach((container) => {
            const elementId = container.id
            const [ , variationIndex] = elementId.split('-')
    
            if(variationIndex === clickedId){
                const isVisible =  container.style.display === 'flex'
                currentTarget.classList.toggle('buttonActive', !isVisible)
                container.style.display = isVisible ? 'none' : 'flex'
  
            }else{
                buttons.forEach((button) =>{
                    if(button.id === variationIndex){
                        button.classList.remove('buttonActive')
                    }
                })
                const containere = document.getElementById(`div-${variationIndex}`)
                containere.style.display= 'none'
            }
        })
    
})}


//aniamtion of container configurator
const animation = (element, distanceA, distanceB) => {
 if(gsap){
    element.style.display = 'flex'
    gsap.fromTo(element, {
        y: `${distanceA}`,
        opacity: 0
    },
    {   
        opacity: 1,
        y: `${distanceB}`,
        duration: 3,
        ease: "power1.out"
    })
 }
}


const playHitSound = () => {
    hitSound.play()
}

const applyTexture = (material, variationMaterial) =>{
    if (material.map !== variationMaterial.pathBaseColor) {
        material.map = variationMaterial.pathBaseColor
        material.normalMap = variationMaterial.pathNormal
        material.roughnessMap= variationMaterial.pathORM
        material.aoMap= variationMaterial.pathORM
        material.metalnessMap= variationMaterial.pathORM    
        variationMaterial.pathBaseColor.colorSpace = THREE.SRGBColorSpace
        materials.needsUpdate = true
        playHitSound()
    }
} 

const setTextureVariation = (material, variationMaterial, material1 = null, variationMaterial1= null) =>{
    applyTexture(material, variationMaterial)

    if(material1, variationMaterial1){
        applyTexture(material1, variationMaterial1)
    }
}

const funcionalityButtonVariation = (buttonVariation) => {
        const elementId = buttonVariation.id
        const arrayBreakdown = elementId.split('-')
        let variationIndex = null
        let materialName = null
        if(arrayBreakdown.length > 1){
            variationIndex = arrayBreakdown.pop()
            materialName = arrayBreakdown.join('-');
        }
        buttonVariation.addEventListener('click', () => {
            updateMaterialtexture(materialName, variationIndex)   
        })
}

const updateMaterialtexture = (materialName, variationIndex) =>{

        if(materialName === 'kitchenIsland'){
            setTextureVariation(materials[materialName], variationsOfTextures[materialName][variationIndex], materials.islandBase, variationsOfTextures.islandBase[variationIndex]) 
         }else if(materialName === 'sink'){
             setTextureVariation(materials[materialName], variationsOfTextures[materialName][variationIndex], materials.faucet, variationsOfTextures.faucet[variationIndex])
         } else {
            setTextureVariation(materials[materialName], variationsOfTextures[materialName][variationIndex]) 
         }
}

